import { DEFAULT_INVALID, DEFAULT_REPLACE } from 'cyprus/constants';
import { FORMAT_TYPE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';
import { convertUnix, invalidUnix } from 'cyprus/utils';
import moment from 'moment';

export const formatUnix = (value: FormatValue, options: FormatValueOptions): string => {
  const ignore = options.ignore || [];
  const { format, utc } = options;
  const timestamp = Number(value);
  const unix = convertUnix(timestamp);

  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidUnix(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  switch (format) {
    case FORMAT_TYPE.UNIX: // 06/15/2009
      if (utc) return moment.unix(unix).utc().format('MM/DD/YYYY');
      return moment.unix(unix).format('MM/DD/YYYY');
    case FORMAT_TYPE.UNIX_SHORT: // 6/15/2009
      if (utc) return moment.unix(unix).utc().format('M/D/YYYY');
      return moment.unix(unix).format('M/D/YYYY');
    case FORMAT_TYPE.UNIX_TIME: // 1:45 PM
      if (utc) return moment.unix(unix).utc().format('hh:mm A');
      return moment.unix(unix).format('hh:mm A');
    case FORMAT_TYPE.UNIX_TIME_SHORT: // 6/15/2009 1:45 PM
      if (utc) return moment.unix(unix).utc().format('M/D/YYYY hh:mm A');
      return moment.unix(unix).format('M/D/YYYY hh:mm A');
    default:
      return String(value || '');
  }
};
